import { endpoints, storeAuth, storeClient } from './client';

/**
 * Fetch providerId → display name map from GET /api/v1/store/users/names.
 * Requires a Store JWT (attached by storeClient interceptors).
 */
export const fetchUserNames = async (): Promise<Record<string, string>> => {
  const token = await storeAuth.getStoreBearerForRequest();
  if (!token) {
    throw new Error('Store authentication required');
  }

  const response = await storeClient.get<Record<string, string>>(endpoints.storeUserNames);
  const data = response.data;
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return data;
  }
  return {};
};
